import React, { useState, useRef, useCallback } from 'react';
import { ButtonContainer } from './Button.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

// Throttle utility using ES6
const useThrottle = (fn, delay = 0) => {
    const lastCall = useRef(0);
    // Log when the hook is initialized
    useEffectWithErrorLogging(() => {
        // console.log("Throttling function with delay:", delay);
    }, [delay]);



    return useCallback((...args) => {
        const now = Date.now();
        if (now - lastCall.current > delay) {
            lastCall.current = now; 
            if (typeof fn === 'function') {
                fn(...args);
            }
        }
    }, [fn, delay]);
};

const Button = ({
    id,
    children,
    landscapeWidth,
    width,
    mobileWidth,
    mobileHeight,
    height = '40px',
    disabled = false,
    show = true,
    fontSize = '15px',
    fontSizeMobile,
    fontFamily,
    clicked,
    padding = '0 10px',
    margin,
    marginRight,
    borderRadius,
    color,
    backgroundColor,
    border,
    opacity = 1,
    mobileMargin,
    boxShadow,
    WhiteSpace,
    mobileMarginTop,
    mobileMarginBottom,
    isJapan = false,
    ipadWidth,
    minWidth,
    mobileMinWidth,
    mbBorder,
    mbJustifyContent,
    throttle = 0, // throttle delay in ms, default 300ms
    variant = null, // variant object to override styles
    mbPadding,
    alignSelf=''
}) => {
    const [backgroundColorUpdate, setBackgroundColor] = useState('');
    const [borderUpdate, setBorder] = useState('');
    const [colorUpdate, setColor] = useState('');
    const [mouseDown, setMouseDown] = useState(false);

    // Throttled click handler
    const throttledClick = useThrottle(clicked, throttle); 
    useEffectWithErrorLogging(()=>{
        if(variant){
            setBackgroundColor(variant.backgroundColor);
            setColor(variant.color);
            setBorder(variant.border);
        }else{
            setBackgroundColor(backgroundColor ? backgroundColor : '#f4f4f5ff');
            setColor(color ? color : '#5a5a5fff');
            setBorder(border ? border : '1px solid #ffffffff');
        }
           
    },[variant, variant?.backgroundColor, variant?.color, variant?.border]);

    const onMouseDown = () => setMouseDown(true);
    const onMouseUp = () => setMouseDown(false);

    return (
        <ButtonContainer
            id={id}
            isJapan={isJapan}
            show={show}
            width={width}
            landscapeWidth={landscapeWidth}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
            height={height}
            backgroundColor={backgroundColorUpdate}
            border={border ? border : borderUpdate}
            borderRadius={borderRadius}
            margin={margin}
            marginRight={marginRight}
            color={colorUpdate}
            padding={padding}
            fontSize={fontSize}
            fontSizeMobile={fontSizeMobile}
            fontFamily={fontFamily}
            onClick={throttledClick}
            disabled={disabled}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            mouseDown={mouseDown}
            boxShadow={boxShadow}
            opacity={opacity}
            mobileMargin={mobileMargin}
            WhiteSpace={WhiteSpace}
            mobileMarginTop={mobileMarginTop}
            mobileMarginBottom={mobileMarginBottom}
            ipadWidth={ipadWidth}
            minWidth={minWidth}
            mobileMinWidth={mobileMinWidth}
            mbBorder={mbBorder}
            mbJustifyContent={mbJustifyContent}
            mbPadding={mbPadding}
            alignSelf={alignSelf}
        >
            {children}
        </ButtonContainer>
    );
};

export default Button;